import { Alert } from '@mui/material';
import { CodJourney } from 'src/constants/assemblyJourneys';
import { GlobalComponentsInterface } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { GlobalComponentCard } from './GlobalComponentCard';
import { GlobalComponentPairedCard } from './GlobalComponentPairedCard';
import {
  getGlobalComponentsByState,
  mapGlobalComponentsByPaired,
} from './ScreenConfigSection.helper';
import {
  IChannelType,
  IHandleGlobalComponentsScreensChange,
  IScreenLayout,
  IScreenOption,
  IUpdateComponents,
} from './ScreenConfigSection.interface';

const PairedItems = [
  [
    {
      componentType: 'cod',
    },
    {
      componentType: 'single-shelf',
      componentVariant: 'DYS',
    },
  ],
];

export const GlobalComponentCardList = ({
  channelType,
  screenLayout,
  screenOptions,
  globalComponents,
  selectedState,
  handleChange,
}: {
  channelType: IChannelType;
  screenLayout: IScreenLayout;
  screenOptions: IScreenOption[];
  globalComponents: GlobalComponentsInterface[];
  selectedState: CodJourney;
} & IHandleGlobalComponentsScreensChange) => {
  const { isViewOnly } = useUserRole();

  const groupedComponents = getGlobalComponentsByState(
    globalComponents,
    screenLayout.globalComponents,
    selectedState,
  );
  const { pairedComponentsArr, rest } = mapGlobalComponentsByPaired(
    groupedComponents,
    PairedItems,
  );

  const handleCardChange =
    (isSyncSequence: boolean) => (updateComponents: IUpdateComponents[]) => {
      handleChange(
        channelType.label,
        screenLayout.layoutType,
        updateComponents,
        isSyncSequence,
      );
    };

  return (
    <>
      {pairedComponentsArr?.map(
        (pairedComponents, index) =>
          pairedComponents.length > 0 && (
            <GlobalComponentPairedCard
              key={index}
              components={pairedComponents}
              screenOptions={screenOptions}
              handleCardChange={handleCardChange(false)}
              isViewOnly={isViewOnly}
            />
          ),
      )}

      {rest?.map((component, index) => (
        <GlobalComponentCard
          key={index}
          component={component}
          screenOptions={screenOptions}
          handleCardChange={handleCardChange(true)}
          selectedState={selectedState}
          isViewOnly={isViewOnly}
        />
      ))}

      {!groupedComponents?.length && (
        <Alert severity="info">
          {lang.customerTriggeredEventsPage.dyrNotAvailableOn(
            `${channelType.label}${
              channelType.screenNumber === 2
                ? ` ${screenLayout.layoutType}`
                : ''
            }`,
          )}
        </Alert>
      )}
    </>
  );
};
